import FaqItem from './FaqItem.vue'

export default FaqItem
